import {texture} from "p3";
import definitions from "../../../definitions";
import Item from "./Item";

export default class ItemScentedSoap extends Item {
    constructor() {
        super(definitions.ITEM_ID.SCENTED_SOAP, texture("prop_scented_soap_00"));
    }

    init() {
        super.init();

        this.addShadow(definitions.SHADOW_SIZE.SMALL, 0.6, new PIXI.Point(3, 0));
    }
}